import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { convertDate, defineTicketNumber } from '../../Helpers/helpers';

import GlobalNotes from '../CommonComponents/GlobalNotes';

import { GetAuth } from '../../Auth/AuthProvider';

import { NoHeaderTableUpdate } from '../../Helpers/requests';

import { Button, Box, Typography, Grid } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

// import { isDate } from 'moment/moment';

// import CircleIcon from '@mui/icons-material/Circle';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';

import { gridStyle } from '../shared/commonStyle';
import { r2_noHeaderTableUpdate } from '../../Helpers/r2_requests';

import { converDateWithTime } from '../../Helpers/helpers';

function InstallArchive() {
  const [data, setData] = useState([]); //data displayed in datagrid
  const [page, setPage] = useState(0); //Active page of table - starts at 0!
  const [filter, setFilter] = useState([]); //Current applied filter modal
  const [sort, setSort] = useState([]); //Current applied sorting modal
  const [loading, setLoading] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRow] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSize, setPageSize] = useState(20); //Number of rows to display
  const [totalRows, setTotalRows] = useState(0); //Total Number of rows in set
  const [updateData, setUpdateData] = useState(0); //Increment to force update dataset
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [dataCustomer, setDataCustomer] = useState([]); //data displayed in datagrid
  const [pageCustomer, setPageCustomer] = useState(0); //Active page of table - starts at 0!
  const [filterCustomer, setFilterCustomer] = useState([]); //Current applied filter modal
  const [sortCustomer, setSortCustomer] = useState([]); //Current applied sorting modal
  const [loadingCustomer, setLoadingCustomer] = useState(false); //Loading indicator - used by datagrid
  const [, setActiveRowCustomer] = useState('NONE'); //Last row clicked - used in details (Detailbox) display
  const [pageSizeCustomer, setPageSizeCustomer] = useState(20); //Number of rows to display
  const [totalRowCustomers, setTotalRowsCustomer] = useState(0); //Total Number of rows in set
  const [updateDataCustomer, setUpdateDataCustomer] = useState(0); //Increment to force update dataset

  const navigateNew = useNavigate();

  const [infoPlateData, setInfoPlateData] = useState({
    address: '',
    cabinet_type: '',
    category: '',
    date_completed: '',
    date_logged: '',
    id: '',
    status: '',
    store_name: '',
    tech_name: '',
    ticket_num: '',
    ticket_type: '',
  });

  const [customerPlateData, setCustomerPlateData] = useState({
    regMan: '',
    regManNumber: '',
    divMan: '',
    divManNumber: '',
  });

  const [notesID, setNotesID] = useState('x');

  useEffect(() => {
    NoHeaderTableUpdate(
      {
        resource: `/api/r2_install_tickets_archive`,
        setDataFunc: setData,
        pageNum: page,
        setLoadingFunc: setLoading,
        pagesize: pageSize,
        sorting: sort,
        filtering: filter,
        showNotification: enqNotification,
        setRows: setTotalRows,
        logout,
      },
      'install-tickets'
    );
  }, [page, pageSize, sort, filter, updateData, enqNotification, logout]);

  function diffInDays(date) {
    let class_name;
    const date1 = new Date(date);
    const date2 = new Date();
    const diff = date2 - date1;
    const diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (diffInDays >= 9) {
      class_name = 'hot';
    } else if (diffInDays >= 3) {
      class_name = 'med';
    } else if (diffInDays >= 2) {
      class_name = 'mild';
    } else {
      class_name = 'cold';
    }

    return class_name;
  }

  function diffInDaysCSS(datIn) {
    return diffInDays(datIn);
  }

  useEffect(() => {
    if (infoPlateData.id !== '') {
      r2_noHeaderTableUpdate(
        {
          resource: `/api/customers/${infoPlateData.customer_id}`,
          setDataFunc: setDataCustomer,
          pageNum: pageCustomer,
          setLoadingFunc: setLoadingCustomer,
          pagesize: pageSizeCustomer,
          sorting: sortCustomer,
          filtering: filterCustomer,
          showNotification: enqNotification,
          setRows: setTotalRowsCustomer,
          logout,
          fullFilters: [
            {
              field: 'branchcode',
              search: infoPlateData.customer_branchcode,
              strict: true,
            },
            {
              field: 'name',
              search: infoPlateData.customer_name,
              strict: false,
            },
          ],
          rangeFilters: [],
        },
        'customersv2'
      );
    }
  }, [infoPlateData]);

  useEffect(() => {
    // console.log('DATA CUSTOMER', dataCustomer[0]);

    if (dataCustomer[0] !== undefined) {
      setCustomerPlateData({
        ...customerPlateData,
        regMan: dataCustomer[0].regional_man_name || '',
        regManNumber: dataCustomer[0].regional_man_number || '',
        divMan: dataCustomer[0].div_man_name || '',
        divManNumber: dataCustomer[0].div_man_number || '',
      });
    }
  }, [dataCustomer]);
  const [authLevel, setAuthLevel] = useState(false);

  useEffect(() => {
    const checkAuth = localStorage.getItem('type');
    if (checkAuth === 'manager' || checkAuth === 'finance') {
      setAuthLevel(true);
    }
  }, []);

  const definedColumns = [
    {
      field: 'id',
      headerName: 'Ticket Nr.',
      minWidth: 180,
      flex: 1,
      editable: false,
      valueGetter: (data) =>
        defineTicketNumber(data.ticket_type, data.id, '5', 'I'),
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 180,
      flex: 1,
      editable: false,
      // valueGetter: ({ value }) => ticketStatus(value),
    },
    {
      field: 'ticket_type',
      headerName: 'Ticket Type',
      minWidth: 180,
      flex: 1,
      editable: false,

      // valueGetter: ({ value }) => INSTALL_TICKETTYPES(value),
    },
    {
      field: 'customer_category_name',
      headerName: 'Category',
      minWidth: 150,
      flex: 1,
      editable: false,
    },
    {
      field: 'customer_name',
      headerName: 'Store Name',
      minWidth: 190,
      flex: 1,
      editable: false,
    },
    {
      field: 'date_scheduled',
      headerName: 'Date Scheduled',
      minWidth: 180,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) => value ? convertDate(value, 0, 10) : '',
    },
    {
      field: 'date_completed',
      headerName: 'Date Completed',
      minWidth: 150,
      flex: 1,
      editable: false,
      valueGetter: ({ value }) =>
        value === null ? '' : convertDate(value, 0, 10),

      //   valueGetter: checkInWarrantee,
    },

    {
      field: 'dn_number',
      headerName: 'Del. Note Nr.',
      minWidth: 120,
      flex: 1,
      editable: false,
    },
    {
      field: 'transporter',
      headerName: 'Transporter',
      minWidth: 120,
      flex: 1,
      editable: false,
    },

    {
      field: 'tech_assigned_name',
      headerName: 'Tech Assigned',
      minWidth: 120,
      flex: 1,
      editable: false,
    },

    //Custom "Actions" column - props.value is field value (id in this case)
    {
      // field: 'id',
      headerName: 'Actions',
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: 'left',

      renderCell: (props) => (
        <>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              navigateNew(`/archive/install_archive_view`, {
                replace: true,
                state: props.row,
              });
            }}
          >
            View
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box style={{ minHeight: '75vh', maxWidth: '100%' }}>
      {/* <center> */}
      <Box
        // style={{ height: '55vh', maxWidth: '100%', textAlign: 'center' }
        sx={{
          height: '55vh',
          maxWidth: '100%',
          textAlign: 'center',
          textTransform: 'capitalize',
        }}
      >
        {/*Configure datagrid */}
        <DataGrid
          sx={gridStyle}
          getRowClassName={(params) => {
            let heatCSS = diffInDaysCSS(params.row.date_logged);
            return params.row.status === 'pending auth' ? 'auth' : heatCSS;
          }}
          rows={data}
          rowCount={totalRows}
          loading={loading}
          pagination
          sortingMode='server'
          filterMode='server'
          // getCellClassName={(params) => {}}
          onSortModelChange={(model) => {
            setPage(0);
            setSort(model);
          }}
          onFilterModelChange={(model) => {
            setPage(0);
            setFilter(model.quickFilterValues);
          }}
          page={page}
          pageSize={pageSize}
          paginationMode='server'
          onPageChange={(newPage) => {
            setPage(newPage);
          }}
          onPageSizeChange={(newPageSize) => {
            setPage(0);
            setPageSize(newPageSize);
          }}
          columns={definedColumns}
          onRowClick={(params) => {
            setActiveRow(params);
            setInfoPlateData(params.row);
            setNotesID(params.row.id);
          }}
          onRowDoubleClick={(params) => {
            navigateNew(`/archive/install_archive_view`, {
              replace: true,
              state: params.row,
            });
          }}
          rowsPerPageOptions={[20, 50, 100]}
          //   components={{ Toolbar: CustomCustomerToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
        />
      </Box>
      <Box
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          marginTop: '10px',
          border: 'solid 2px #354775',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid
          container
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          spacing={0}
        >
          <Grid
            container
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            spacing={0}
          >
            <Grid container xs={12} md={4} flexDirection='row' rowGap={2}>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Customer:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_name}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Address:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_address}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Telephone Number:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_contact_number}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}>Contact Person:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.customer_contact_name}
                </Typography>
              </Grid>
            </Grid>
            <Grid container xs={12} md={8} flexDirection='row' rowGap={2}>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>Description:</Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.description}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Regional Manager:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={3} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {customerPlateData.regMan}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>Contact Number:</Typography>
              </Grid>
              <Grid item xs={8} lg={3} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {customerPlateData.regManNumber}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Divisional Manager:
                </Typography>
              </Grid>
              <Grid item xs={8} lg={3} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {customerPlateData.divMan}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>Contact Number:</Typography>
              </Grid>
              <Grid item xs={8} lg={3} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {customerPlateData.divManNumber}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={3} rowGap={2}>
                <Typography style={ticketTypoTitle}>Date Scheduled:</Typography>
              </Grid>
              <Grid item xs={8} lg={6} rowGap={2}>
                <Typography style={ticketTypoInfo}>
                  {infoPlateData.date_scheduled
                    ? converDateWithTime(infoPlateData.date_scheduled)
                    : infoPlateData.date_scheduled}
                </Typography>
              </Grid>
              <Grid item xs={4} lg={4} rowGap={2}>
                <Typography style={ticketTypoTitle}></Typography>
              </Grid>
              <Grid item xs={8} lg={8} rowGap={2}>
                <Typography style={ticketTypoInfo}></Typography>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={2}
              marginTop='15px'
            >
              <Grid item xs={12} lg={12} rowGap={2}>
                <Typography style={ticketTypoTitle}>
                  Communication Notes:
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={12}
                rowGap={2}
                sx={{
                  display: notesID === (undefined || 0 || 'x') && 'none',
                }}
              >
                <GlobalNotes relationId={notesID} relationType='ticketTable' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default InstallArchive;
